import { format } from 'date-fns';

export interface FivetranTaskLike {
  message?: unknown;
  details?: unknown;
}

export function normalizeSyncState(raw: string | undefined): string {
  return (raw ?? '').trim().toLowerCase();
}

export function isRescheduledSyncState(syncState: string | undefined): boolean {
  return normalizeSyncState(syncState) === 'rescheduled';
}

function firstNonEmptyDetail(entries: FivetranTaskLike[] | undefined): string | null {
  if (!entries?.length) return null;
  for (const entry of entries) {
    const d = safeTrim(entry.details);
    if (d) return d;
    const m = safeTrim(entry.message);
    if (m) return m;
  }
  return null;
}

export function formatRescheduledForDisplay(iso: string | null | undefined): string | null {
  const cleanIso = safeTrim(iso);
  if (!cleanIso) return null;
  const d = new Date(cleanIso);
  if (Number.isNaN(d.getTime())) return cleanIso;
  return format(d, 'PPp');
}

function safeTrim(value: unknown): string {
  if (typeof value === 'string') return value.trim();
  if (typeof value === 'number' || typeof value === 'boolean') return String(value).trim();
  return '';
}

export function formatFivetranSyncDetail(args: {
  syncState?: string;
  rescheduledFor?: string | null;
  tasks?: FivetranTaskLike[];
  warnings?: FivetranTaskLike[];
  statusReason?: unknown;
}): string | null {
  const fromTasks = firstNonEmptyDetail(args.tasks);
  if (fromTasks) return fromTasks;

  const fromWarnings = firstNonEmptyDetail(args.warnings);
  if (fromWarnings) return fromWarnings;

  if (typeof args.statusReason === 'string') {
    const reason = safeTrim(args.statusReason);
    if (reason) return reason;
  }

  if (isRescheduledSyncState(args.syncState)) {
    const next = formatRescheduledForDisplay(args.rescheduledFor ?? null);
    if (next) return `Next sync: ${next}`;
  }

  return null;
}
